import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDropdown } from '../dropdown';
import s from './button.module.css';
export var context = createContext({
  select: void 0,
  info: {},
  mode: 'single',
  dataTest: void 0,
  native: false,
  nativeValue: null,
  onChange: function onChange() {},
  registerInfoControl: function registerInfoControl() {},
  registerSearchInput: function registerSearchInput() {},
  registerSelect: function registerSelect() {},
  search: {},
  setNativeValue: function setNativeValue() {},
  showInfo: function showInfo() {},
  showSearch: function showSearch() {}
});
export function useSelectedText() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var texts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var textMap = useMemo(function () {
    return (texts || []).reduce(function (res, _ref) {
      var value = _ref.value,
        text = _ref.text;
      res.set(value, text);
      return res;
    }, new Map());
  }, [texts]);
  var selectedText = useMemo(function () {
    return _toConsumableArray(textMap.keys()).reduce(function (res, value) {
      return values.includes(value) ? [].concat(_toConsumableArray(res), [textMap.get(value)]) : res;
    }, []).join(', ');
  }, [textMap, values]);
  return selectedText;
}
export function useSelect(onChange) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    selected = _ref2.selected,
    texts = _ref2.texts;
  var _useState = useState(selected),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var handleChange = useCallback(function (value, _, evt) {
    setValue(value);
    onChange(value, evt);
  }, [onChange]);
  useEffect(function () {
    setValue(selected);
  }, [selected]);
  var is = useCallback(function (check) {
    return value === check;
  }, [value]);
  var selectedText = useSelectedText(typeof value !== 'undefined' ? [value] : [], texts);
  return {
    is: is,
    handleChange: handleChange,
    selectedText: selectedText
  };
}
export function convertToValuesMap(values) {
  var result = new Map();
  values.forEach(function (item) {
    return result.set(item, true);
  });
  return result;
}
export function useMultipleSelect(onChange) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$selected = _ref3.selected,
    selected = _ref3$selected === void 0 ? [] : _ref3$selected,
    _ref3$texts = _ref3.texts,
    texts = _ref3$texts === void 0 ? [] : _ref3$texts;
  var _useState3 = useState(convertToValuesMap(selected)),
    _useState4 = _slicedToArray(_useState3, 2),
    values = _useState4[0],
    setValue = _useState4[1];
  var selectedText = useSelectedText(_toConsumableArray(values.keys()).filter(function (k) {
    return values.get(k);
  }), texts);
  useEffect(function () {
    setValue(convertToValuesMap(selected));
  }, [JSON.stringify(selected)]);
  var handleChange = useCallback(function (value, checked, evt) {
    return setValue(function (prev) {
      var update = new Map(prev).set(value, checked);
      onChange(_toConsumableArray(update.keys()).filter(function (k) {
        return update.get(k);
      }), evt);
      return update;
    });
  }, [onChange]);
  var is = useCallback(function (value) {
    return !!values.get(value);
  }, [values]);
  return {
    is: is,
    handleChange: handleChange,
    selectedText: selectedText
  };
}
export function useNativeSelect() {
  var select = useRef(null);
  var _useContext = useContext(context),
    registerSelect = _useContext.registerSelect,
    onChange = _useContext.onChange,
    native = _useContext.native,
    nativeValue = _useContext.nativeValue;
  var handleChange = useCallback(function (event) {
    var int = ('int' in event.target.options[event.target.selectedIndex].dataset);
    if (onChange) {
      onChange(int ? parseFloat(event.target.value) : event.target.value, true, event);
    }
  }, [onChange]);
  useEffect(function () {
    if (!native || !select.current) {
      return;
    }
    registerSelect(select.current);
  }, [native, registerSelect]);
  useEffect(function () {
    if (!select.current || !native || !nativeValue) {
      return;
    }
    select.current.value = nativeValue;
  }, [native, nativeValue]);
  return {
    select: select,
    native: native,
    handleChange: handleChange,
    style: s.native
  };
}
export function useSelectCustomControl() {
  var _useDropdown = useDropdown(),
    toggle = _useDropdown.toggle,
    registerControl = _useDropdown.registerControl,
    opened = _useDropdown.opened,
    content = _useDropdown.content;
  var control = useRef(null);
  useEffect(function () {
    if (!control.current) {
      return;
    }
    registerControl(control.current);
  }, [registerControl]);
  return {
    toggle: toggle,
    control: control,
    content: content,
    opened: opened
  };
}